import React from 'react'
import { connect } from 'react-redux'
import { jt, t } from 'ttag'
import { MultiSelect } from 'react-selectize'
import {
  Checkbox,
  ControlLabel,
  FormControl,
  FormGroup,
  Modal,
  ProgressBar,
  Tab,
  Tabs
} from 'react-bootstrap'

import * as contentSnippetWizardActions from '../actions/contentSnippetWizard'
import { NumericStepper as Stepper, Step, StepButton } from '../components/NumericStepper'
import withTinyMCE from '../components/withTinyMCE'

class InitialStepMenu extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      selectedKey: 1,
      description: null,
      descriptionCss: null,
      isRecommendedChoice: false,
      filterText: null
    }
  }

  clearSelection() {
    this.props.onSelectContentType(null)
    this.setState({
      ...this.state,
      isRecommendedChoice: false,
      descriptionCss: null,
      description: null
    })
  }

  onSelectContentType(idx, isRecommendedChoice, desc, descCss) {
    this.props.onSelectContentType(idx)
    this.setState({
      ...this.state,
      isRecommendedChoice,
      descriptionCss: descCss,
      description: desc
    })
  }

  filter(v) {
    const v2 = v.target.value

    this.setState({
      ...this.state,
      filterText: v2 && v2.length > 0 ? v2.toLowerCase() : null
    })
    // console.log(v.target.value)
  }

  selectItem(key) {
    this.props.onSelectContentType(null)
    this.setState({
      ...this.state,
      isRecommendedChoice: false,
      descriptionCss: null,
      description: null,
      selectedKey: key
    })
  }

  matchesFilter(choiceLabel, description) {
    const mat =
      !this.state.filterText ||
      choiceLabel.toLowerCase().indexOf(this.state.filterText) >= 0 ||
      (description || '').toLowerCase().indexOf(this.state.filterText) >= 0

    // console.log(mat, this.state.filterText)
    return mat
  }

  render() {
    const aboutDescText = t`Add an about section to tell users what this organization does`
    const occDescText = t`Add a section which contains a listing of occupations employed by this organization`
    const locDescText = t`Add the location of this organization so users can see it displayed in text as well as on a map`
    const clustDescText = t`Add a section which contains a listing with links to career clusters serviced by this organization`

    return (
      <div>
        <h2>{t`To begin, please select the type of section you want to add`}</h2>
        <Tabs
          id="contentchoicetabs"
          activeKey={this.state.selectedKey}
          onSelect={key => {
            this.selectItem(key)
          }}>
          <Tab eventKey={1} title={t`Recommended Section Types`}>
            <div className="toprow row" style={{ marginTop: '20px' }}>
              <ul className="content-choice">
                <li className="col-xs-3">
                  <a
                    href="javascript:void(0)"
                    className={`profile-choice-block ${
                      this.state.isRecommendedChoice &&
                      this.props.selectedContentTypeIndex === 1
                        ? 'selected'
                        : ''
                    }`}
                    onClick={() =>
                      this.onSelectContentType(
                        1,
                        true,
                        aboutDescText,
                        'fal fa-info-circle'
                      )}>
                    <div className="text-center">
                      <i className={`fal fa-info-circle fa-2x`}></i>
                    </div>
                    {t`About`}
                  </a>
                </li>
                <li className="col-xs-3">
                  <a
                    href="javascript:void(0)"
                    className={`profile-choice-block ${
                      this.state.isRecommendedChoice &&
                      this.props.selectedContentTypeIndex === 3
                        ? 'selected'
                        : ''
                    }`}
                    onClick={() =>
                      this.onSelectContentType(3, true, occDescText, 'fal fa-briefcase')}>
                    <div className="text-center">
                      <i className={`fal fa-briefcase fa-2x`}></i>
                    </div>
                    {t`Occupations`}
                  </a>
                </li>
                <li className="col-xs-3">
                  <a
                    href="javascript:void(0)"
                    className={`profile-choice-block ${
                      this.state.isRecommendedChoice &&
                      this.props.selectedContentTypeIndex === 8
                        ? 'selected'
                        : ''
                    }`}
                    onClick={() =>
                      this.onSelectContentType(8, true, locDescText, 'fal fa-map-marker')}>
                    <div className="text-center">
                      <i className={`fal fa-map-marker fa-2x`}></i>
                    </div>
                    {t`Location`}
                  </a>
                </li>
                <li className="col-xs-3">
                  <a
                    href="javascript:void(0)"
                    className={`profile-choice-block ${
                      this.state.isRecommendedChoice &&
                      this.props.selectedContentTypeIndex === 27
                        ? 'selected'
                        : ''
                    }`}
                    onClick={() =>
                      this.onSelectContentType(
                        27,
                        true,
                        clustDescText,
                        'fal fa-pie-chart'
                      )}>
                    <div className="text-center">
                      <i className={`fal fa-chart-pie fa-2x`}></i>
                    </div>
                    {t`Clusters`}
                  </a>
                </li>
              </ul>

              <div className="col-xs-12 text-right" style={{ marginTop: '10px' }}>
                <a
                  href="javascript:void(0)"
                  onClick={() => this.selectItem(2)}
                  style={{ color: '#ccc' }}>
                  {t`View All Section Types`} <i className="fal fa-chevron-right"></i>
                </a>
              </div>
            </div>
          </Tab>
          <Tab eventKey={2} title={t`All Section Types`}>
            <div style={{ marginBottom: '10px', marginTop: '20px' }}>
              <input
                onKeyDown={v => this.filter(v)}
                onFocus={() => this.clearSelection()}
                onChange={v => this.filter(v)}
                placeholder={t`Select an option below, or type a search term to filter the items`}
                className="form-control input-lg"
                style={{ width: '100%' }}
              />
            </div>

            <div className="row">
              <ul className="content-choice">
                {this.props.allowedTypes.map(
                  ({ idx, choiceLabel, description, cssClass }) => (
                    <li className="col-xs-2" key={idx}>
                      <a
                        href="javascript:void(0)"
                        className={`profile-choice-block
                                                 ${
                                                   !this.state.isRecommendedChoice &&
                                                   idx ===
                                                     this.props.selectedContentTypeIndex
                                                     ? 'selected'
                                                     : ''
                                                 }
                                                 ${
                                                   this.matchesFilter(
                                                     choiceLabel,
                                                     description
                                                   )
                                                     ? ''
                                                     : 'disabled'
                                                 }`}
                        disabled={!this.matchesFilter(choiceLabel, description)}
                        onClick={() =>
                          this.onSelectContentType(idx, false, description, cssClass)}>
                        <div className="text-center">
                          <i className={`${cssClass} fa-lg`}></i>
                        </div>
                        {choiceLabel}
                      </a>
                    </li>
                  )
                )}
              </ul>
            </div>
          </Tab>
        </Tabs>
        <div className={`top-desc ${this.state.description ? 'show' : 'noshow'}`}>
          <i
            className={`${this.state.descriptionCss} fa-lg`}
            style={{ marginRight: '10px' }}>
          </i>
          {this.state.description}
        </div>
      </div>
    )
  }
}

const getStepsForSelectedContentType = ({
  selectedContentTypeIndex,
  onFieldChange,
  onSelectContentType,
  onSuggestionChanges,
  state,
  onAddOrRemoveContentListingChip,
  onAddFile,
  onAddFileToSlideshow,
  onRemoveFileFromSlideshow,
  uploadProgress,
  onUploadFile,
  onSelectFile,
  onSelectSurvey
}) => {
  const TextareaField = withTinyMCE(({ keyInStore, TinyMCE }) => {
    /*
     *return  <textarea className="text-input full"
     *                   style={{ width: "100%" }}
     *                   onChange={e => onFieldChange(keyInStore, true, e.target.value)}
     *                   value={state[keyInStore]}></textarea>
     */
    return (
      <TinyMCE
        id={`content-snippet-wizard-${keyInStore}`}
        initialValue={state[keyInStore] || ''}
        init={{ ...h2.getOptionsTinyMCE() }}
        onBlur={event =>
          onFieldChange(keyInStore, true, event.target.getContent({ format: 'raw' }))}
        className="text-input"
      />
    )
  })
  const CustomTextField = (keyInStore, label, otherArgs, required) => {
    return (
      <FormGroup controlId={`k-${keyInStore}`}>
        <ControlLabel>
          {label} {required ? ' *' : ''}
        </ControlLabel>
        <FormControl
          required={required}
          className="text-input"
          type="text"
          value={state[selectedContentTypeIndex][keyInStore] || ''}
          onChange={event => onFieldChange(keyInStore, false, event.target.value)}
        />
      </FormGroup>
    )
  }
  const MultiSelectInput = (contentListingState, choiceObjectStoreKey, label) => {
    return (
      <MultiSelect
        style={{ width: '100%' }}
        placeholder={label}
        theme="bootstrap3"
        //this would be an accident waiting to happen
        hideResetButton={true}
        //These are the values that will be rendered inside the select
        values={contentListingState.values}
        options={state.suggestions[choiceObjectStoreKey]}
        renderOption={option => {
          return <div style={{ padding: '1em' }}>{option.label}</div>
        }}
        onFocus={input => {
          return onSuggestionChanges(' ', choiceObjectStoreKey)
        }}
        onValuesChange={options => {
          // console.log(contentListingState.values, options)
          const toRemove = contentListingState.values.filter(t => options.indexOf(t) < 0)

          //console.log(toRemove)
          toRemove.forEach(o => {
            console.log(`Removing ${o}`)
            onAddOrRemoveContentListingChip(o, choiceObjectStoreKey, false)
          })

          options.forEach(option => {
            const isAddition =
              contentListingState.values.filter(t => t == option).length === 0

            if (isAddition) {
              //      console.log(`Adding ${option}`)
              onAddOrRemoveContentListingChip(option, choiceObjectStoreKey, true)
            }
          })
        }}
        createFromValue={value => {
          return {
            label: value.name,
            value
          }
        }}
        //Execute search
        onSearchChange={input => {
          //console.log("Searching for", input);
          return onSuggestionChanges(input, choiceObjectStoreKey)
        }}
        renderNoResultsFound={(values, search) => {
          // console.log(search.trim().length == 0)
          return (
            <div className="no-results-found">
              {search.trim().length == 0
                ? t`Enter a few characters to begin searching`
                : t`No results found`}
            </div>
          )
        }}
      />
    )
  }
  const CustomCheckbox = (keyInStore, label, otherArgs, required) => {
    return (
      <FormGroup controlId={`k-${keyInStore}`}>
        <ControlLabel>
          {label} {required ? ' *' : ''}
        </ControlLabel>
        <FormControl
          required={required}
          type="checkbox"
          checked={state[selectedContentTypeIndex][keyInStore] || false}
          value={state[selectedContentTypeIndex][keyInStore] || ''}
          onChange={event => onFieldChange(keyInStore, false, event.target.checked)}
        />
      </FormGroup>
    )
  }
  const initialStep = () => ({
    body: () => (
      <InitialStepMenu
        onSelectContentType={onSelectContentType}
        selectedContentTypeIndex={selectedContentTypeIndex}
        allowedTypes={state.allowedTypes}
      />
    )
  })
  const renderContentListingPanel = idx => {
    switch (idx) {
      case null:
        return {
          stepperLabel: t`Configure Listing`,
          body: () => {} //never shown, when listingType gets selected, will fall into other "cases"
        }

      case contentSnippetWizardActions.CONTENT_LISTING_OCCUPATIONS.idx:
        return {
          stepperLabel: t`Select Occupations`,
          body: () => (
            <div>
              <h5>{t`Select Occupations`}</h5>
              {MultiSelectInput(state[idx], 'occupations', t`Occupations`)}
            </div>
          )
        }
      case contentSnippetWizardActions.CONTENT_CAREER_CLUSTER.idx:
        return {
          stepperLabel: t`Select Clusters`,
          body: () => (
            <div>
              <h5>{t`Select Clusters`}</h5>
              {MultiSelectInput(state[idx], 'clusters', t`Clusters`)}
            </div>
          )
        }
      case contentSnippetWizardActions.CONTENT_LISTING_COLLEGE.idx:
        return {
          stepperLabel: t`Select Colleges`,
          body: () => (
            <div>
              <h5>{t`Select Colleges you want to appear on the page`}</h5>
              {MultiSelectInput(state[idx], 'colleges', t`Colleges`)}
            </div>
          )
        }
      case contentSnippetWizardActions.CONTENT_LISTING_INDUSTRIES.idx:
        return {
          stepperLabel: t`Select Industries`,
          body: () => (
            <div>
              <h5>{t`Select Industries you want to appear on the page`}</h5>
              {MultiSelectInput(state[idx], 'industries', t`Industries`)}
            </div>
          )
        }
      case contentSnippetWizardActions.CONTENT_LISTING_CERTIFICATION.idx:
        return {
          stepperLabel: t`Select Certifications`,
          body: () => (
            <div>
              <h5>{t`Select Certifications you want to appear on the page`}</h5>
              {MultiSelectInput(state[idx], 'certifications', t`Certifications`)}
            </div>
          )
        }
      case contentSnippetWizardActions.CONTENT_LISTING_OTHER_PROFILES.idx:
        return {
          stepperLabel: t`Select Profiles`,
          body: () => (
            <div>
              <h5>{t`Select Profiles`}</h5>
              {MultiSelectInput(state[idx], 'profiles', t`Profiles`)}
            </div>
          )
        }
      case contentSnippetWizardActions.CONTENT_LISTING_JOB_OPENING.idx:
        return {
          stepperLabel: t`Options`,
          body: () => (
            <div>
              <h5>{t`Indeed Job Listing Options`}</h5>
              {CustomCheckbox('fillFromIndeed', t`Fill From Indeed`)}
              <br />
              {CustomTextField('defaultZip', t`Default Zip Code`)}
              <br />
              {CustomTextField('defaultZipRadius', t`Search Radius`)}
              <br />
              {CustomTextField('defaultState', t`Default State`)}
              <br />
              {CustomCheckbox(
                'autoExpandSearch',
                t`National search if no results with defaults`
              )}
              <br />
            </div>
          )
        }
      case contentSnippetWizardActions.CONTENT_LISTING_DIRECT_EMPLOYER_JOB_OPENING.idx:
        return {
          stepperLabel: t`Options`,
          body: () => (
            <div>
              <h5>{t`Job Listing Options`}</h5>
              {CustomTextField('companyName', t`Match company name`)}
              <br />
              {CustomTextField('searchTerm', t`Match this term`)}
              <br />
              {CustomTextField('ein', t`Match this EIN`)}
              <br />
              {CustomTextField('defaultZip', t`Default Zip Code`)}
              <br />
              <FormGroup controlId="defaultZipRadius">
                <ControlLabel>{t`Search Radius`}</ControlLabel>
                <FormControl
                  componentClass="select"
                  value={state[selectedContentTypeIndex].defaultZipRadius}
                  onChange={event => {
                    onFieldChange('defaultZipRadius', false, event.target.value)
                  }}
                  placeholder={t`select`}>
                  <option key="5" value={'5'}>{t`5 miles`}</option>
                  <option key="10" value={'10'}>{t`10 miles`}</option>
                  <option key="15" value={'15'}>{t`15 miles`}</option>
                  <option key="20" value={'20'}>{t`20 miles`}</option>
                  <option key="25" value={'25'}>{t`25 miles`}</option>
                  <option key="50" value={'50'}>{t`50 miles`}</option>
                  <option key="75" value={'75'}>{t`75 miles`}</option>
                  <option key="100" value={'100'}>{t`100 miles`}</option>
                  <option key="250" value={'250'}>{t`250 miles`}</option>
                  <option key="500" value={'500'}>{t`500 miles`}</option>
                </FormControl>
              </FormGroup>
              <br />
              {CustomTextField('defaultState', t`Default State`)}
              <br />
              {CustomCheckbox(
                'autoExpandSearch',
                t`National search if no results with defaults`
              )}
              <br />
            </div>
          )
        }
      case contentSnippetWizardActions.CONTENT_LISTING_ADDITIONAL_RESOURCES.idx:
        return {
          stepperLabel: t`Edit External Link`,
          body: () => (
            <div>
              <h5>{t`Edit External Link`}</h5>
              {CustomTextField('url', t`link web address`)}
              <br />
              {CustomTextField('title', t`link title`)}
              <br />
              {CustomTextField('description', 'description', {
                multiLine: true
              })}
            </div>
          )
        }
      /*
       *case contentSnippetWizardActions.CONTENT_EMPLOY_GOALS.idx :
       *    return {
       *        stepperLabel: CONTENT_EMPLOY_GOALS.choiceLabel,
       *        body: (
       *            <div>Hi there</div>
       *        )
       *    };
       *case contentSnippetWizardActions.CONTENT_EMPLOY_CRITERIA.idx :
       *    return {
       *        stepperLabel: CONTENT_EMPLOY_CRITERIA.choiceLabel,
       *        body: (
       *            <div>Hi there</div>
       *        )
       *    };
       */
      default:
        // causes the wizard to not have this step
        return null
    }
  }
  const editOptionsStep = (type, options) => ({
    stepperLabel: t`Which options do you offer?`,
    body: () => {
      const selections = state[type.idx].selections || []
      const updateSelections = option => event => {
        let newSelections = selections.filter(sel => sel.id !== option.id)

        if (event.target.checked) {
          newSelections = [...newSelections, option]
        }

        onFieldChange('selections', false, newSelections)
      }

      return (
        <div>
          {options.map(option => {
            //console.log(option)
            const key = `option-${type.id}-${option.id}`

            return (
              <FormGroup key={key} controlId={key}>
                <Checkbox
                  checked={selections.find(s => s.id === option.id)}
                  onChange={updateSelections(option)}>
                  {option.name}
                </Checkbox>
              </FormGroup>
            )
          })}
        </div>
      )
    }
  })
  const editTitleAndBodyStep = () => ({
    stepperLabel: t`Heading`,
    body: () => (
      <div>
        <h5>{t`Now, enter a title for the section and any text that you wish to appear`}</h5>
        <FormGroup controlId="titleInput">
          <ControlLabel>{t`Section Title`} *</ControlLabel>
          <FormControl
            required={true}
            className="text-input"
            type="text"
            value={state.title || ''}
            onChange={event => onFieldChange('title', true, event.target.value)}
          />
        </FormGroup>
        {dynamicValues.userProfile?.isRoot && (
          <FormGroup controlId="floatBodyLeft">
            <ControlLabel>{t`Float Body Left`} *</ControlLabel>
            <FormControl
              required={false}
              type="checkbox"
              checked={state.floatBodyLeft || false}
              value={state.floatBodyLeft || false}
              onChange={event =>
                onFieldChange('floatBodyLeft', true, event.target.checked)}
            />
          </FormGroup>
        )}
        {dynamicValues.userProfile?.isRoot && (
          <FormGroup controlId="floatFooterRight">
            <ControlLabel>{t`Float Footer Right`} *</ControlLabel>
            <FormControl
              required={false}
              type="checkbox"
              checked={state.floatFooterRight || false}
              value={state.floatFooterRight || false}
              onChange={event =>
                onFieldChange('floatFooterRight', true, event.target.checked)}
            />
          </FormGroup>
        )}
        {dynamicValues.userProfile?.isRoot && (
          <FormGroup controlId="suppressTitle">
            <ControlLabel>{t`Suppress Title`} *</ControlLabel>
            <FormControl
              required={false}
              type="checkbox"
              checked={state.suppressTitle || false}
              value={state.suppressTitle || false}
              onChange={event =>
                onFieldChange('suppressTitle', true, event.target.checked)}
            />
          </FormGroup>
        )}

        <br />
        <FormGroup controlId="body">
          <ControlLabel>{t`Body Text`}</ControlLabel>
          <TextareaField keyInStore="body" />
        </FormGroup>
      </div>
    )
  })
  const editFooterStep = () => ({
    stepperLabel: t`Footer`,
    body: () => (
      <div>
        <h5>{t`Enter any text to appear at the bottom of this section`}</h5>
        <FormGroup controlId="footerInput">
          <ControlLabel>{t`Footer Text`}</ControlLabel>
          <TextareaField keyInStore="footer" />
        </FormGroup>
      </div>
    )
  })
  const statusBar = () => {
    if (uploadProgress.active) {
      return (
        <div className="col-xs-4">
          <ProgressBar
            active
            now={uploadProgress.pctComplete}
            style={{ marginBottom: 0 }}
          />
        </div>
      )
    }

    return <div className="col-xs-4"></div>
  }
  const sectionPositionSteps = state => {
    return (
      <div>
        {dynamicValues.userProfile?.isRoot && (
          <div>
            <b>{t`Float Body Left`}</b>{' '}
            {state.floatBodyLeft ? (
              <i className="fal fa-check-square"></i>
            ) : (
              <i className="fal fa-square"></i>
            )}
          </div>
        )}
        {dynamicValues.userProfile?.isRoot && (
          <div>
            <b>{t`Float Footer Right`}</b>{' '}
            {state.floatFooterRight ? (
              <i className="fal fa-check-square"></i>
            ) : (
              <i className="fal fa-square"></i>
            )}
          </div>
        )}
        {dynamicValues.userProfile?.isRoot && (
          <div>
            <b>{t`Suppress Title`}</b>{' '}
            {state.suppressTitle ? (
              <i className="fal fa-check-square"></i>
            ) : (
              <i className="fal fa-square"></i>
            )}
          </div>
        )}
      </div>
    )
  }
  const confirmationStep = (state, children) => {
    return {
      stepperLabel: t`Confirmation`,
      isLast: true,
      body: () => {
        const addToPage = <b>{t`Add Text to Page`}</b>

        // console.log(state)
        return (
          <div>
            <h4>{t`You're almost done!`}</h4>
            <p>{t`Please review before saving:`}</p>
            <div>
              <div>
                <b>{t`Title:`}</b> {state.title}
              </div>
              {sectionPositionSteps(state)}
              <div>
                <b>{t`Body:`}</b>
              </div>
              <div dangerouslySetInnerHTML={{ __html: state.body }}></div>
              {children}
              <div>
                <b>{t`Footer:`}</b>
              </div>
              <div dangerouslySetInnerHTML={{ __html: state.footer }}></div>
            </div>
            <p>
              {jt`If the above is correct, click on the ${addToPage} and the text will be added to the page.`}{' '}
              {t`You can change it at any time by hovering over the section and clicking the pencil icon.`}
            </p>
          </div>
        )
      }
    }
  }

  // console.log("Rendering for: " + selectedContentTypeIndex)
  switch (selectedContentTypeIndex) {
    case null:
      return [initialStep()]

    case contentSnippetWizardActions.CONTENT_CONTACT_INFO.idx:
      return [
        initialStep(),
        editTitleAndBodyStep(),
        {
          stepperLabel: t`Contact Info`,
          body: () => (
            <div>
              {CustomTextField('firstName', t`First Name`)}
              <br />
              {CustomTextField('lastName', t`Last Name`)}
              <br />
              {CustomTextField('email', t`E-Mail`)}
              <br />
              {CustomTextField('phone', t`Phone`)}
              <br />
              {CustomTextField('position', t`Position`)}
              <br />
              {CustomTextField('address', t`Address`)}
              <br />
              {CustomTextField('city', t`City`)}
              <br />
              {CustomTextField('state', t`State`)}
              <br />
              {CustomTextField('zip', t`Zip Code`)}
              <br />
              {CustomTextField('notes', t`Notes`)}
              <br />
            </div>
          )
        },
        editFooterStep(),
        confirmationStep(
          state,
          <ul>
            <li key="firstName">
              <b>{t`First Name:`}</b> {state[selectedContentTypeIndex].firstName}
            </li>
            <li key="lastName">
              <b>{t`Last Name:`}</b> {state[selectedContentTypeIndex].lastName}
            </li>
            <li key="email">
              <b>{t`E-Mail:`}</b> {state[selectedContentTypeIndex].email}
            </li>
            <li key="phone">
              <b>{t`Phone:`}</b> {state[selectedContentTypeIndex].phone}
            </li>
            <li key="position">
              <b>{t`Position:`}</b> {state[selectedContentTypeIndex].position}
            </li>
            <li key="address">
              <b>{t`Address:`}</b> {state[selectedContentTypeIndex].address}
            </li>
            <li key="city">
              <b>{t`City:`}</b> {state[selectedContentTypeIndex].city}
            </li>
            <li key="state">
              <b>{t`State:`}</b> {state[selectedContentTypeIndex].state}
            </li>
            <li key="zip">
              <b>{t`Zip:`}</b> {state[selectedContentTypeIndex].zip}
            </li>
            <li key="notes">
              <b>{t`Notes:`}</b> {state[selectedContentTypeIndex].notes}
            </li>
          </ul>
        )
      ]

    case contentSnippetWizardActions.CONTENT_EMPLOY_GOALS.idx:
      return [
        initialStep(),
        editTitleAndBodyStep(),
        editOptionsStep(contentSnippetWizardActions.CONTENT_EMPLOY_GOALS, [
          { id: 1, name: t`Get into college` },
          { id: 2, name: t`Get my HiSET` },
          { id: 3, name: t`Get back into high school` },
          { id: 4, name: t`Work in hospitality` },
          { id: 5, name: t`Work in construction` },
          { id: 6, name: t`Work in technology` },
          { id: 7, name: t`Work in healthcare` },
          { id: 8, name: t`Find a job now` },
          { id: 9, name: t`Be a leader in my community` },
          { id: 10, name: t`Find shelter` }
        ]),
        editFooterStep(),
        confirmationStep(
          state,
          <ul>
            {(state.selections || []).map(selection => {
              return <li key={selection.id}>{selection.name}</li>
            })}
          </ul>
        )
      ]

    case contentSnippetWizardActions.CONTENT_EMPLOY_CRITERIA.idx:
      return [
        initialStep(),
        editTitleAndBodyStep(),
        editOptionsStep(contentSnippetWizardActions.CONTENT_EMPLOY_CRITERIA, [
          { id: 1, name: t`Are bus accessible` },
          { id: 2, name: t`Pay me to participate` },
          { id: 3, name: t`Are free` },
          { id: 4, name: t`Provide transportation` },
          { id: 5, name: t`Take people under 18` }
        ]),
        editFooterStep(),
        confirmationStep(
          state,
          <ul>
            {(state.selections || []).map(selection => (
              <li key={selection.id}>{selection.name}</li>
            ))}
          </ul>
        )
      ]

    case contentSnippetWizardActions.CONTENT_TEXT.idx:
      const templatesWhichRequreFooter = ['wbl_application_section']

      return templatesWhichRequreFooter.includes(state.sectionTemplateId)
        ? [
            initialStep(),
            editTitleAndBodyStep(),
            editFooterStep(),
            confirmationStep(state, null)
          ]
        : [initialStep(), editTitleAndBodyStep(), confirmationStep(state, null)]

    case contentSnippetWizardActions.CONTENT_YOUTUBE.idx:
      return [
        initialStep(),
        editTitleAndBodyStep(),
        {
          stepperLabel: t`Video URL`,
          body: () => (
            <div>
              <h5>{t`Enter the Youtube video's URL or ID`}</h5>
              {CustomTextField('videoId', t`Youtube URL or video ID`)}
            </div>
          )
        },
        editFooterStep(),
        confirmationStep(
          state,
          <div>
            <b>{t`Video ID:`}</b> {state[selectedContentTypeIndex].videoId}
          </div>
        )
      ]

    case contentSnippetWizardActions.CONTENT_LISTING_FILES.idx:
      const contentListingState = state[selectedContentTypeIndex]

      return [
        initialStep(),
        editTitleAndBodyStep(),
        {
          stepperLabel: t`Select File`,
          body: () => (
            <div>
              <div className="resorts">
                <FormGroup controlId="formControlsFile">
                  <ControlLabel className="sr-only">{t`Choose File`}</ControlLabel>
                  <FormControl
                    className="col-xs-8"
                    multiple
                    type="file"
                    value={uploadProgress.selected}
                    onChange={event => {
                      event.preventDefault()
                      onUploadFile(
                        event.target,
                        state.profileId,
                        state.profileType
                      ).then(f => f.restCall.result.files.forEach(f => onAddFile(f)))
                    }}
                  />
                  {statusBar()}
                </FormGroup>
                <br className="clear" />
              </div>

              <ul style={{ marginTop: '25px' }}>
                {contentListingState.files.map(f => (
                  <li key={`file-in-list${f.id}`}>{f.fileName}</li>
                ))}
              </ul>
              <br />

              <label htmlFor="selectFileList">{t`Select File`}</label>
              <select
                className="form-control input-lg"
                id="selectFileList"
                style={{ marginTop: '25px' }}
                value={null}
                onChange={t => {
                  if (t.target.value !== '-1') {
                    const payload = state.listOfFiles.files.find(
                      s => s.id == t.target.value
                    )

                    if (payload) {
                      onAddFile(payload)
                    }
                  }
                }}>
                ><option value="-1">{t`Choose a file to add`}</option>
                {state.listOfFiles.files
                  .filter(f => contentListingState.files.indexOf(f) < 0)
                  .map(sa => {
                    return (
                      <option value={sa.id} key={`file-${sa.id}`}>
                        {sa.fileName}
                      </option>
                    )
                  })}
              </select>
            </div>
          )
        },
        editFooterStep(),
        {
          stepperLabel: t`Confirmation`,
          isLast: true,
          body: () => {
            const formattedType = <b>{t`Add Text to Page`}</b>

            return (
              <div>
                <h4>{t`You're almost done!`}</h4>
                <p>{t`Please review the information you are about to add:`}</p>
                <ul>
                  <li>
                    <b>{t`Title:`}</b> {state.title}
                  </li>
                  {sectionPositionSteps(state)}
                  <li>
                    <b>{t`Body:`}</b> {state.body}
                  </li>
                  <li>
                    <b>{t`Items:`}</b>
                    <ul>
                      {state[selectedContentTypeIndex].files.map(i => (
                        <li key={i.id}>{i.fileName}</li>
                      ))}
                    </ul>
                  </li>
                  <li>
                    <b>{t`Footer:`}</b> {state.footer}
                  </li>
                </ul>
                <p>{jt`If the above is correct, click on ${formattedType} and the address will be added to the page, you can change it at any time by clicking the pencil icon.`}</p>
              </div>
            )
          }
        }
      ]

    case contentSnippetWizardActions.CONTENT_ADDRESS.idx:
      return [
        initialStep(),
        editTitleAndBodyStep(),
        {
          stepperLabel: t`Address`,
          body: () => (
            <div>
              <h5>{t`Enter the address`}</h5>
              {CustomTextField('laddress', t`Street Address`)}
              {CustomTextField('lcity', t`City`)}
              {CustomTextField('lstate', t`State`)}
              {CustomTextField('lzip', t`Zip`)}
            </div>
          )
        },
        editFooterStep(),
        confirmationStep(
          state,
          <ul>
            <li>
              <b>{t`Address:`}</b> {state[selectedContentTypeIndex].laddress}
            </li>
            <li>
              <b>{t`City:`}</b> {state[selectedContentTypeIndex].lcity}
            </li>
            <li>
              <b>{t`State:`}</b> {state[selectedContentTypeIndex].lstate}
            </li>
            <li>
              <b>{t`Zip:`}</b> {state[selectedContentTypeIndex].lzip}
            </li>
          </ul>
        )
      ]

    case contentSnippetWizardActions.CONTENT_TWITTER.idx:
      return [
        initialStep(),
        editTitleAndBodyStep(),
        {
          stepperLabel: t`Twitter Name`,
          body: () => (
            <div>
              <h5>{t`Enter the Twitter Name`}</h5>
              {CustomTextField('twitterName', t`Twitter Name`)}
            </div>
          )
        },
        editFooterStep(),
        confirmationStep(
          state,
          <ul>
            <li>
              <b>{t`Twitter Name:`}</b> {state[selectedContentTypeIndex].twitterName}
            </li>
          </ul>
        )
      ]

    case contentSnippetWizardActions.CONTENT_PROFILE_TAGS.idx:
      return [
        initialStep(),
        editTitleAndBodyStep(),
        {
          stepperLabel: t`Search Criteria`,
          body: () => (
            <div>
              <p>{t`To edit search criteria, please select the edit profile link from the administer menu`}</p>
            </div>
          )
        },
        editFooterStep(),
        confirmationStep(state)
      ]

    case contentSnippetWizardActions.CONTENT_SCHEDULE.idx:
      return [
        initialStep(),
        editTitleAndBodyStep(),
        {
          stepperLabel: t`Add Schedule to Page`,
          isLast: true,
          body: () => (
            <p>{t`Add the schedule to the page, you must then configure the schedule`}</p>
          )
        }
      ]
    case contentSnippetWizardActions.CONTENT_SURVEY.idx:
      return [
        initialStep(),
        editTitleAndBodyStep(),
        {
          stepperLabel: t`Select Survey`,
          body: () => (
            <div>
              {CustomTextField('buttonText', t`Button Title`)}
              <br />
              {CustomTextField(
                'fragmentId',
                t`Unique code after # that will open this survey (optional)`
              )}
              <label htmlFor="surveySelect">{t`Select Survey`}</label>
              <select
                className="form-control input-lg"
                id="surveySelect"
                style={{ marginTop: '25px' }}
                value={
                  state[selectedContentTypeIndex].surveyId &&
                  state[selectedContentTypeIndex].surveyId.id
                }
                onChange={t => {
                  if (t.target.value === '-1') {
                    return
                  }

                  const payload = state.listOfSurveys.find(s => s.id == t.target.value)

                  onSelectSurvey(payload)
                }}>
                >
                {!state[selectedContentTypeIndex].surveyId && (
                  <option value="-1">{t`Select a survey`}</option>
                )}
                {state.listOfSurveys.map(sa => {
                  return (
                    <option value={sa.id} key={`survey-${sa.id}`}>
                      {sa.name}
                    </option>
                  )
                })}
              </select>
            </div>
          )
        },
        {
          stepperLabel: t`Add Survey to Page`,
          isLast: true,
          body: () => <p>{t`Add a survey to the page, you must then edit the survey`}</p>
        }
      ]
    case contentSnippetWizardActions.CONTENT_PHOTO.idx:
      const contentListingStatePhoto = state[selectedContentTypeIndex]

      return [
        initialStep(),
        editTitleAndBodyStep(),
        {
          stepperLabel: t`Select File`,
          body: () => (
            <div>
              <div className="resorts">
                <FormGroup controlId="formControlsFile">
                  <ControlLabel className="sr-only">{t`Choose File`}</ControlLabel>
                  <FormControl
                    className="col-xs-8"
                    multiple
                    type="file"
                    value={uploadProgress.selected}
                    onChange={event => {
                      event.preventDefault()
                      onUploadFile(
                        event.target,
                        state.profileId,
                        state.profileType
                      ).then(f => f.files.forEach(f => onAddFileToSlideshow(f)))
                    }}
                  />
                  {statusBar()}
                </FormGroup>
                <br className="clear" />
              </div>

              <ul style={{ marginTop: '25px' }}>
                {contentListingStatePhoto.files.map(f => (
                  <li key={`file-in-list${f.id}`}>
                    {f.fileName}{' '}
                    <a
                      href="javascript:void(0)"
                      className="pull-right delete"
                      onClick={() => onRemoveFileFromSlideshow(f)}>
                      <span>{t`Delete`}</span>
                    </a>
                  </li>
                ))}
              </ul>
              <br />

              <label htmlFor="slideshowFilePromote">{t`Select File`}</label>
              <select
                className="form-control input-lg"
                id="slideshowFilePromote"
                style={{ marginTop: '25px' }}
                value={null}
                onChange={t => {
                  if (t.target.value !== '-1') {
                    const payload = state.listOfFiles.files.find(
                      s => s.id == t.target.value
                    )

                    if (payload) {
                      onAddFileToSlideshow(payload)
                    }
                  }
                }}>
                ><option value="-1">{t`Choose a file to add`}</option>
                {state.listOfFiles.files
                  .filter(f => contentListingStatePhoto.files.indexOf(f) < 0)
                  .map(sa => {
                    return (
                      <option value={sa.id} key={`file-${sa.id}`}>
                        {sa.fileName}
                      </option>
                    )
                  })}
              </select>
            </div>
          )
        },
        editFooterStep(),
        {
          stepperLabel: t`Confirmation`,
          isLast: true,
          body: () => {
            const linkText = <b>{t`Add Photo to Page`}</b>

            return (
              <div>
                <h4>{t`You're almost done!`}</h4>
                <p>{t`Please review the information you are about to add:`}</p>
                <ul>
                  <li>
                    <b>{t`Title:`}</b> {state.title}
                  </li>
                  {sectionPositionSteps(state)}
                  <li>
                    <b>{t`Body: `}</b> {state.body}
                  </li>
                  <li>
                    <b>{t`Items:`}</b>
                    <ul>
                      {state[selectedContentTypeIndex].files.map(i => (
                        <li key={i.id}>{i.fileName}</li>
                      ))}
                    </ul>
                  </li>
                  <li>
                    <b>{t`Footer:`}</b> {state.footer}
                  </li>
                </ul>
                <p>{jt`If the above is correct, click on ${linkText} and the images will be added to the section, you can change it at any time by clicking the pencil icon.`}</p>
              </div>
            )
          }
        }
      ]

    case contentSnippetWizardActions.CONTENT_LISTING_OCCUPATIONS.idx:
    case contentSnippetWizardActions.CONTENT_LISTING_COLLEGE.idx:
    case contentSnippetWizardActions.CONTENT_LISTING_JOB_OPENING.idx:
    case contentSnippetWizardActions.CONTENT_LISTING_DIRECT_EMPLOYER_JOB_OPENING.idx:
    case contentSnippetWizardActions.CONTENT_CAREER_CLUSTER.idx:
    case contentSnippetWizardActions.CONTENT_LISTING_ADDITIONAL_RESOURCES.idx:
    case contentSnippetWizardActions.CONTENT_LISTING_INDUSTRIES.idx:
    case contentSnippetWizardActions.CONTENT_LISTING_OTHER_PROFILES.idx:
      //const contentListingType = contentSnippetWizardActions.CONTENT_LISTING;

      const listConfirm = () => {
        switch (selectedContentTypeIndex) {
          case contentSnippetWizardActions.CONTENT_LISTING_JOB_OPENING.idx:
            return (
              <li>
                <b>{t`Options`}</b>
                <ul>
                  <li>
                    {t`Fill From Indeed:`}{' '}
                    {state[selectedContentTypeIndex].fillFromIndeed ? t`yes` : t`no`}
                  </li>
                  <li>
                    {t`Expand Search:`}{' '}
                    {state[selectedContentTypeIndex].autoExpandSearch ? t`yes` : t`no`}
                  </li>
                  <li>
                    {t`Default Zip:`} {state[selectedContentTypeIndex].defaultZip}
                  </li>
                  <li>
                    {t`Zip Radius:`} {state[selectedContentTypeIndex].defaultZipRadius}
                  </li>
                  <li>
                    {t`Default State:`} {state[selectedContentTypeIndex].defaultState}
                  </li>
                </ul>
              </li>
            )
          case contentSnippetWizardActions.CONTENT_LISTING_DIRECT_EMPLOYER_JOB_OPENING
            .idx:
            return (
              <li>
                <b>{t`Options`}</b>
                <ul>
                  <li>
                    {t`Company Name:`} {state[selectedContentTypeIndex].companyName}
                  </li>
                  <li>
                    {t`Search Term:`} {state[selectedContentTypeIndex].searchTerm}
                  </li>
                  <li>
                    {t`EIN:`} {state[selectedContentTypeIndex].ein}
                  </li>
                  <li>
                    {t`Expand Search:`}{' '}
                    {state[selectedContentTypeIndex].autoExpandSearch ? t`yes` : t`no`}
                  </li>
                  <li>
                    {t`Default Zip:`} {state[selectedContentTypeIndex].defaultZip}
                  </li>
                  <li>
                    {t`Zip Radius:`} {state[selectedContentTypeIndex].defaultZipRadius}
                  </li>
                  <li>
                    {t`Default State:`} {state[selectedContentTypeIndex].defaultState}
                  </li>
                </ul>
              </li>
            )
          default:
            console.log(
              state[selectedContentTypeIndex].listingtype,
              contentSnippetWizardActions.CONTENT_LISTING_DIRECT_EMPLOYER_JOB_OPENING.idx
            )

            return (
              <li>
                <b>{t`Items:`}</b>
                <ul>
                  {state[selectedContentTypeIndex].values.map(i => (
                    <li key={i.value}>{i.label}</li>
                  ))}
                </ul>
              </li>
            )
        }
      }

      return [
        initialStep(),
        editTitleAndBodyStep(),
        renderContentListingPanel(selectedContentTypeIndex),
        editFooterStep(),
        confirmationStep(state, listConfirm())
      ]

    case contentSnippetWizardActions.CONTENT_INTEREST_PROFILER.idx:
      return [
        initialStep(),
        editTitleAndBodyStep(),
        editFooterStep(),
        confirmationStep(state, null)
      ]

    case contentSnippetWizardActions.CONTENT_WORK_IMPORTANCE_PROFILER.idx:
      return [
        initialStep(),
        editTitleAndBodyStep(),
        editFooterStep(),
        confirmationStep(state, null)
      ]

    case contentSnippetWizardActions.CONTENT_SKILLS_PROFILER.idx:
      return [
        initialStep(),
        editTitleAndBodyStep(),
        editFooterStep(),
        confirmationStep(state, null)
      ]

    case contentSnippetWizardActions.CONTENT_WORK_KEYS.idx:
      return [
        initialStep(),
        editTitleAndBodyStep(),
        editFooterStep(),
        confirmationStep(state, null)
      ]

    case contentSnippetWizardActions.CONTENT_PROMOTE_FILES.idx:
      const fId = state[selectedContentTypeIndex].fileId

      console.log(fId, state.listOfFiles.files)

      return [
        initialStep(),
        editTitleAndBodyStep(),
        {
          stepperLabel: t`Select File`,
          body: () => (
            <div>
              <FormGroup controlId="formControlsFile" className="resorts row">
                <ControlLabel className="sr-only">{t`Choose File`}</ControlLabel>
                <FormControl
                  className="col-xs-8"
                  type="file"
                  value={uploadProgress.selected}
                  onChange={event => {
                    event.preventDefault()
                    onUploadFile(
                      event.target,
                      state.profileId,
                      state.profileType
                    ).then(f => f.files.forEach(f => onSelectFile(f)))
                  }}
                />
                {statusBar()}
              </FormGroup>

              <br />

              <label htmlFor="selectFilePromote">{t`Select File to Promote`}</label>
              <select
                className="form-control input-lg"
                id="selectFilePromote"
                style={{ marginTop: '25px' }}
                value={fId && fId.id}
                onChange={t => {
                  if (t.target.value !== '-1') {
                    const payload = state.listOfFiles.files.find(
                      s => s.id == t.target.value
                    )

                    if (payload) {
                      onSelectFile(payload)
                    }
                  }
                }}>
                >
                {(!fId || !fId.id) && (
                  <option value="-1">{t`Choose a file to add`}</option>
                )}
                {state.listOfFiles.files.map(sa => {
                  return (
                    <option value={sa.id} key={`file-${sa.id}`}>
                      {sa.fileName}
                    </option>
                  )
                })}
              </select>
            </div>
          )
        },
        {
          stepperLabel: t`Display Options`,
          body: () => (
            <div>
              {CustomCheckbox('showButton', t`Display Button`)}

              {CustomTextField('buttonText', t`View Button Label (Blank for default)`)}

              {CustomCheckbox('showThumbnail', t`Show Graphical Thumbnail (if exists)`)}
            </div>
          )
        },
        editFooterStep(),
        confirmationStep(
          state,
          <ul>
            <li>
              <b>{t`File:`}</b>{' '}
              {fId && fId.hasOwnProperty('fileName') ? fId.fileName : null}
            </li>
            <li>
              <b>{t`Download Button:`}</b>{' '}
              {state[selectedContentTypeIndex].showButton ? t`yes` : t`no`}
            </li>
            <li>
              <b>{t`Button Text:`}</b> {state[selectedContentTypeIndex].buttonText}
            </li>
            <li>
              <b>{t`Thumbnail:`}</b>{' '}
              {state[selectedContentTypeIndex].showThumbnail ? t`yes` : t`no`}
            </li>
          </ul>
        )
      ]

    case contentSnippetWizardActions.CONTENT_SUMMARY_QUALIFICATIONS.idx:
      return [
        initialStep(),
        editTitleAndBodyStep(),
        {
          stepperLabel: t`Resume`,
          isLast: false,
          body: () => (
            <div>
              <p>{t`Select the resume to include`}</p>
              <FormGroup controlId="selectedResume">
                <ControlLabel>{t`Select Resume`}</ControlLabel>
                <FormControl
                  componentClass="select"
                  value={state[selectedContentTypeIndex].selectedResume.id}
                  onChange={event => {
                    const vId = event.target.value
                    const v = state.listOfResumes.find(r => {
                      return r.id == vId
                    })
                    const item = v.id
                      ? {
                          title: v.title,
                          isDocument: v.hasOwnProperty('documentId'),
                          id: v.id
                        }
                      : { id: null, isDocument: false, title: null }

                    onFieldChange('selectedResume', false, item)
                  }}
                  placeholder={t`select`}>
                  <option value="select">{t`Select a Resume`}</option>
                  {state.listOfResumes.map(y => (
                    <option key={`resume-${y.id}`} value={y.id}>
                      {y.title}
                    </option>
                  ))}
                </FormControl>
              </FormGroup>
            </div>
          )
        },
        {
          stepperLabel: t`Work Experience`,
          isLast: false,
          body: () => (
            <div>
              <p>{t`Are there any work experiences you wish to highlight?`}</p>
              <FormGroup controlId="selectedResumeWork">
                <ControlLabel>{t`Select Resume Work`}</ControlLabel>
                <FormControl
                  componentClass="select"
                  value={state[selectedContentTypeIndex].workExperience.id}
                  onChange={(event, key, payload) => {
                    const vId = event.target.value
                    const v = state.resumeContent.employment.find(r => {
                      return r.id == vId
                    })
                    const item = v.id
                      ? {
                          title: v.title,
                          id: v.id
                        }
                      : { id: null, title: null }

                    onFieldChange('workExperience', false, item)
                  }}
                  placeholder="select">
                  <option value="select">{t`Select a Work Experience`}</option>
                  {state.resumeContent.employment.map(y => (
                    <option key={`wh-${y.id}`} value={y.id}>
                      {y.title}
                    </option>
                  ))}
                </FormControl>
              </FormGroup>
            </div>
          )
        },
        {
          stepperLabel: t`Education`,
          isLast: false,
          body: () => (
            <div>
              <p>{t`Are there any educational items you wish to highlight?`}</p>
              <FormGroup controlId="selectedResumeEducation">
                <ControlLabel>{t`Select Resume Education`}</ControlLabel>
                <FormControl
                  componentClass="select"
                  value={state[selectedContentTypeIndex].education.id}
                  onChange={(event, key, payload) => {
                    const vId = event.target.value
                    const v = state.resumeContent.education.find(r => {
                      return r.id == vId
                    })
                    const item = v.id
                      ? {
                          title: v.title,
                          id: v.id
                        }
                      : { id: null, title: null }

                    onFieldChange('education', false, item)
                  }}
                  placeholder={t`select`}>
                  <option value="select">{t`Select an Education`}</option>
                  {state.resumeContent.education.map(y => (
                    <option key={`ed-${y.id}`} value={y.id}>
                      {y.title}
                    </option>
                  ))}
                </FormControl>
              </FormGroup>
            </div>
          )
        },
        editFooterStep(),
        confirmationStep(
          state,
          <ul>
            <li>
              <b>Resume:</b> {state[selectedContentTypeIndex].selectedResume.title}
            </li>
            {state[selectedContentTypeIndex].selectedResume.isDocument ? (
              <span></span>
            ) : (
              <span>
                <li>
                  <b>{t`Work Experience:`}</b>{' '}
                  {state[selectedContentTypeIndex].workExperience.title}
                </li>
                <li>
                  <b>{t`Education:`}</b> {state[selectedContentTypeIndex].education.title}
                </li>
              </span>
            )}
          </ul>
        )
      ]

    default:
      // console.log(`Found a type we couldn't handle: ${selectedContentTypeIndex}`)
      return <span>{t`Not implemented`}</span>
  }
}
const ContentSnippetWizard = argz => {
  const {
    isPopupOpened,
    onCancel,
    isLoading,
    onFormSubmitStart,
    currentStepIndex,
    state,
    submitError,
    onNext,
    onPrevious,
    onSubmit
  } = argz
  const stepsForSelectedContentType = getStepsForSelectedContentType(argz).filter(
    step => step != null
  )
  const currentStepMetaData = stepsForSelectedContentType[currentStepIndex]
  const renderStepper = () => {
    // don't show the stepper if selectedContentTypeIndex not selected (step 0)
    if (currentStepIndex === 0) {
      return <div style={{ paddingTop: '25px' }}></div>
    }

    const [_, ...steps] = stepsForSelectedContentType
    const renderSteps = () => {
      return steps.map(stepMetaData => {
        return (
          <Step key={stepMetaData.stepperLabel}>
            <StepButton key={`${stepMetaData.stepperLabel}label`}>
              {stepMetaData.stepperLabel}
            </StepButton>
          </Step>
        )
      })
    }

    return <Stepper activeStep={currentStepIndex - 1}>{renderSteps()}</Stepper>
  }
  const renderLowerButtons = () => {
    return (
      <div className="nav" style={{ marginTop: '25px' }}>
        <button
          className="btn btn-primary pull-left"
          id="prev"
          onClick={onPrevious}
          type="button"
          disabled={currentStepIndex === 0}
          style={currentStepIndex === 0 ? { display: 'none' } : {}}>
          {t`Previous`}
        </button>
        <button className="btn btn-success pull-left">
          {currentStepMetaData.isLast
            ? state.idForEdit
              ? t`Update`
              : t`Add to page`
            : t`Next`}
          <i
            className="fal fa-circle-notch fa-spin fa-fw"
            style={{ display: isLoading ? 'inline-block' : 'none' }}>
          </i>
        </button>
        <button
          className="btn btn-danger small pull-right"
          onClick={onCancel}
          type="button">
          {t`Cancel`}
        </button>
      </div>
    )
  }
  const onSubmitFunc = e => {
    e.preventDefault()

    if (currentStepMetaData.isLast) {
      onFormSubmitStart()
    }

    currentStepMetaData.isLast ? onSubmit() : onNext()
  }

  /*
   * !!!IMPORTANT: TinyMCE linking doesn't work inside Bootstrap Modals
   * https://github.com/tinymce/tinymce/issues/782
   */
  console.log(argz)

  return (
    <Modal bsSize="large" enforceFocus={false} show={isPopupOpened} onHide={onCancel}>
      <Modal.Header style={{ color: 'white', fontWeight: 'bold' }}>
        <button type="button" className="close" aria-label={t`Close`} onClick={onCancel}>
          <span aria-hidden="true">×</span>
        </button>
        <h2>{t`Define Section`}</h2>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={onSubmitFunc} className="content-wizard">
          {renderStepper()}
          {submitError && (
            <div className="alert alert-danger">{t`An error occurred while adding this section`}</div>
          )}
          <div style={{ minHeight: '300px' }}>{currentStepMetaData.body()}</div>
          {renderLowerButtons()}
        </form>
      </Modal.Body>
    </Modal>
  )
}

export default connect(
  state => {
    return {
      ...state.contentSnippetWizard,
      state: state.contentSnippetWizard
    }
  },
  dispatch => ({
    onCancel: () => {
      //debugger;
      dispatch(contentSnippetWizardActions.closeContentWizard())
    },
    onSelectContentType: idx => {
      dispatch(contentSnippetWizardActions.selectContentType(idx))
    },
    onNext: () => {
      dispatch(contentSnippetWizardActions.nextStep())
    },
    onPrevious: () => {
      dispatch(contentSnippetWizardActions.previousStep())
    },
    onFieldChange: (storeKeyId, isRoot, value) => {
      // console.log(storeKeyId, value, isRoot)
      dispatch(contentSnippetWizardActions.onFieldChange(storeKeyId, isRoot, value))
    },
    onSubmit: () => dispatch(contentSnippetWizardActions.submit()),
    onFormSubmitStart: () => dispatch(contentSnippetWizardActions.startFormLoading()),
    onSuggestionChanges: (text, suggestionType) =>
      dispatch(contentSnippetWizardActions.fetchSuggestions(text, suggestionType)),

    onAddOrRemoveContentListingChip: (choiceObject, choiceObjectType, isAdd) =>
      dispatch(
        contentSnippetWizardActions.addOrRemoveContentListingObject(
          choiceObject,
          choiceObjectType,
          isAdd
        )
      ),

    onAddFile: file => {
      dispatch(contentSnippetWizardActions.addFile(file))
    },
    onAddFileToSlideshow: file => {
      dispatch(contentSnippetWizardActions.addFileToSlideshow(file))
    },
    onRemoveFileFromSlideshow: file => {
      dispatch(contentSnippetWizardActions.removeFileFromSlideshow(file))
    },
    onUploadFile: (f, profileId, profileType) => {
      return dispatch(contentSnippetWizardActions.uploadFile(f, profileId, profileType))
    },
    onSelectFile: f => {
      dispatch(contentSnippetWizardActions.selectFile(f))
    },
    onSelectSurvey: f => {
      dispatch(contentSnippetWizardActions.selectSurvey(f))
    }
  })
)(ContentSnippetWizard)
